import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,Box,
  Grid,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import axios, { removeBracketedText } from "../Axiosinstance";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import Head from "./Headstu";
import courserecipt from "../pdf/courserecipt.pdf";
import { decryptData } from "../Axiosinstance";

function Payment() {
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const studentTeacherId = decryptData(localStorage.getItem('studentteacherid'));

  useEffect(() => {
    const fetchStudentDetails = async () => {
      if (true) {
        try {
          const response = await axios.get(`registrationadvances/student/${studentTeacherId}/registration-advances`);
          const courseFees = response.data[0]?.courseFees || []; // Safely access `courseFees`
          setPaymentDetails(courseFees);
          console.log(courseFees)
          // setShowModal(true);
        } catch (error) {
          console.error("Error fetching student details:", error);
        }
      }
    };
    fetchStudentDetails();
  }, []);

  const numberToWords = (number) => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "Ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const suffixes = ["", "Thousand"];

    const numToWords = (num) => {
      let words = "";
      if (num >= 1000) {
        words += numToWords(Math.floor(num / 1000)) + " Thousand ";
        num %= 1000;
      }
      if (num >= 100) {
        words += ones[Math.floor(num / 100)] + " Hundred ";
        num %= 100;
      }
      if (num >= 20) {
        words += tens[Math.floor(num / 10)] + " ";
        num %= 10;
      }
      if (num > 0) {
        if (num >= 11 && num <= 19) {
          words += teens[num - 10] + " ";
        } else {
          words += ones[num] + " ";
        }
      }
      return words.trim();
    };

    if (number === 0) return "Zero";
    return numToWords(number);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Get day and pad with leading zero if necessary
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1 and pad
    const year = date.getFullYear(); // Get full year

    return `${day}.${month}.${year}`;
  };

  const handledownloadReciept = async (feeDetail) => {
    const pdfBytes = await fetch(courserecipt).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(pdfBytes);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    // const courierfont = await pdfDoc.embedFont(StandardFonts.Courier);
    const courierfontbold = await pdfDoc.embedFont(StandardFonts.CourierBold);
    const courierfont = await pdfDoc.embedFont(StandardFonts.Courier);


    const amountText = feeDetail?.amount ? `$${feeDetail.amount}` : ""; // Ensure the dollar symbol is always present

    const balanceToDisplay = feeDetail?.feestype === 'Course fee'
    ? feeDetail?.courseFeebalance?.toString()
    : feeDetail?.registrationFeebalance?.toString();

    const sumOfDollars = numberToWords(feeDetail?.amount);
    // Convert numbers to strings
    firstPage.drawText(String(feeDetail?.studentName || "").toUpperCase(), {
      x: 162,
      y: 627,
      size: 11,
      font: courierfontbold,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(String(feeDetail?.finNric || ""), {
      x: 162,
      y: 602,
      size: 11,
      font: courierfontbold,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(
      String(removeBracketedText(feeDetail?.course) || "").toUpperCase(),
      { x: 162, y: 578, size: 11, font: courierfontbold, color: rgb(0, 0, 0) }
    );
    // firstPage.drawText(String(feeDetail?.description || ''), { x: 35, y: 520, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
    firstPage.drawText(String(feeDetail?.invoiceNumber || ""), {
      x: 488,
      y: 676,
      size: 11,
      font: courierfontbold,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(String(formatDate(feeDetail?.date || "")), {
      x: 470,
      y: 664,
      size: 11,
      font: courierfontbold,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(amountText, {
      x: 497,
      y: 520,
      size: 11,
      font: courierfontbold,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(amountText, {
      x: 497,
      y: 460,
      size: 11,
      font: courierfontbold,
      color: rgb(0, 0, 0),
    });
   
    // firstPage.drawText(`${sumOfDollars} Dollars Only`, {
    //   x: 130,
    //   y: 477,
    //   size: 11,
    //   font: courierfontbold,
    //   color: rgb(0, 0, 0),
    // });
    firstPage.drawText("AUD", {
      x: 503,
      y: 438,
      size: 11,
      font: courierfontbold,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`Balance : $${balanceToDisplay}`, { x: 77, y: 485, size: 11, font: courierfont, color: rgb(0, 0, 0) });

    const drawWrappedText = async (
      page,
      text,
      x,
      y,
      font,
      fontSize,
      maxWidth
    ) => {
      text = replaceTabs(text);
      const lines = [];
      let currentLine = "";
      const words = text.split(" ");

      for (let i = 0; i < words.length; i++) {
        const word = words[i];
        const width = getTextWidth(currentLine + " " + word, font, fontSize);

        if (width < maxWidth) {
          currentLine += (currentLine === "" ? "" : " ") + word;
        } else {
          lines.push(currentLine.trim());
          currentLine = word;
        }
      }

      if (currentLine !== "") {
        lines.push(currentLine.trim());
      }

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        const lineWidth = getTextWidth(line, font, fontSize);

        await page.drawText(line, {
          x: i === 0 ? x : x,
          y: y - i * 12,
          size: fontSize,
          font,
          color: rgb(0, 0, 0),
        });
      }
    };

    function replaceTabs(text) {
      return text.replace(/\t/g, "    "); // Replace each tab with four spaces
    }

    const getTextWidth = (text, font, fontSize) => {
      const width = font.widthOfTextAtSize(text, fontSize);
      return width;
    };

    let yPosition = 520;
    const lineHeight = 10;

    drawWrappedText(
      firstPage,
      String(feeDetail?.description || ""),
      77,
      yPosition,
      courierfontbold,
      10,
      380
    );
    yPosition -= lineHeight;
    drawWrappedText(firstPage,`${sumOfDollars} Dollars Only`, 177, 464, courierfontbold, 10, 300);
    const pdfBytesModified = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytesModified], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <div>
      <Head />
   <br />
<Box 
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",  // Light gray background
    padding: "12px 24px",
    borderRadius: "8px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    maxWidth: "600px",
    margin: "auto",
    textAlign: "center"
  }}
>
  <Typography 
    variant="h5" 
    sx={{ 
      fontWeight: "bold", 
      color: "#1976d2", 
      textTransform: "uppercase", 
      letterSpacing: 1.2
    }}
  >
    Payment Details
  </Typography>
</Box>


      {paymentDetails.length > 0 ? (
        <Grid item xs={12}>
          <Paper elevation={3} style={{ padding: "24px", height: "100%" }}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontWeight: "bolder" }}
            >
              Registration Fee Details
            </Typography>
            <TableContainer component={Paper}>
              <Table aria-label="Course Fee Table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold'}} >Invoice Number</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Date</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Amount</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Discount</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Description</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Action</TableCell>
                  </TableRow> 
                </TableHead>
                <TableBody>
                  {paymentDetails.filter((feeDetail) => feeDetail.feestype === "Registration fee").length > 0 ? (
                    paymentDetails
                      .filter((feeDetail) => feeDetail.feestype === "Registration fee")
                      .map((feeDetail, index) => (
                        <TableRow key={index}>
                          <TableCell>{feeDetail.invoiceNumber || "N/A"}</TableCell>
                          <TableCell>{formatDate(feeDetail.date || "")}</TableCell>
                          <TableCell>{feeDetail.amount || "N/A"}</TableCell>
                          <TableCell>{feeDetail.discount ? `$${feeDetail.discount}` : "NA"}</TableCell>
                          <TableCell>{feeDetail.description || "N/A"}</TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handledownloadReciept(feeDetail)}
                            >
                              View Receipt
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No receipts available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <br />
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontWeight: "bolder" }}
            >
              Course Fee Details
            </Typography>
            <TableContainer component={Paper}>
              <Table aria-label="Course Fee Table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold'}} >Invoice Number</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Date</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Amount</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Discount</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Description</TableCell>
                    <TableCell style={{ fontWeight: 'bold'}} >Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentDetails.filter((feeDetail) => feeDetail.feestype === "Course fee").length > 0 ? (
                    paymentDetails
                      .filter((feeDetail) => feeDetail.feestype === "Course fee")
                      .map((feeDetail, index) => (
                        <TableRow key={index}>
                          <TableCell>{feeDetail.invoiceNumber || "N/A"}</TableCell>
                          <TableCell>{formatDate(feeDetail.date || "")}</TableCell>
                          <TableCell>{feeDetail.amount || "N/A"}</TableCell>
                          <TableCell>{feeDetail.discount ? `$${feeDetail.discount}` : "NA"}</TableCell>
                          <TableCell>{feeDetail.description || "N/A"}</TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handledownloadReciept(feeDetail)}
                            >
                              View Receipt
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No receipts available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      ) : (
        <Box 
        sx={{ 
          display: "flex", 
          flexDirection: "column",
          justifyContent: "center", 
          alignItems: "center", 
          height: "100vh", // Full viewport height
       marginTop: '-10%',
          color: "#757575" // Gray color for a subtle look
        }}
      >
        <InfoIcon sx={{ fontSize: 50, color: "#1976d2"}} /> {/* Blue info icon */}
        
        <Typography variant="h6" fontWeight="bold">
          No course fees available.
        </Typography>
      </Box>
      )}
    </div>
  );
}

export default Payment;
